'use client';

import { useMutation, useQuery, useQueryClient } from '@tanstack/react-query';
import {
  supportApi,
  type CreateTicketPayload,
  type SupportStatus,
} from '../services/support-api';

const KEY = ['support', 'tickets'] as const;

export function useSupportTickets(status?: SupportStatus, limit?: number) {
  return useQuery({
    queryKey: [...KEY, { status, limit }],
    queryFn: () => supportApi.list(status, limit),
  });
}

export function useSupportTicket(id: string | undefined | null) {
  return useQuery({
    queryKey: [...KEY, id],
    queryFn: () => supportApi.get(id!),
    enabled: !!id,
  });
}

export function useSupportOpenCount() {
  return useQuery({
    queryKey: [...KEY, 'open-count'],
    queryFn: () => supportApi.openCount(),
    staleTime: 60_000,
    refetchOnWindowFocus: false,
  });
}

export function useCreateSupportTicket() {
  const qc = useQueryClient();
  return useMutation({
    mutationFn: (payload: CreateTicketPayload) => supportApi.create(payload),
    onSuccess: () => {
      qc.invalidateQueries({ queryKey: KEY });
    },
  });
}

export function useReplySupportTicket(ticketId: string) {
  const qc = useQueryClient();
  return useMutation({
    mutationFn: (body: string) => supportApi.reply(ticketId, body),
    onSuccess: () => {
      qc.invalidateQueries({ queryKey: [...KEY, ticketId] });
      qc.invalidateQueries({ queryKey: KEY });
    },
  });
}
